// extracted by mini-css-extract-plugin
module.exports = {"root":"_28220078df7f0954346f8d7799996ad0","loading":"_375d93f5393a0dc8d7fcb27ab9ab4d87"};